import request from './request'

// 登录请求
export interface LoginRequest {
  username: string
  password: string
  captcha?: string
  captchaKey?: string
}

// 角色信息（对齐后端 LoginResponse.RoleInfo）
export interface RoleInfo {
  id: number
  roleCode: string
  roleName: string
  isPrimary: boolean
}

// 登录响应（字段与后端 dto/LoginResponse.java 严格对齐）
export interface LoginResponse {
  accessToken: string
  refreshToken: string
  expiresIn: number
  tokenType: string
  userId: number
  username: string
  realName: string
  role: string
  roleName: string
  /** 所有角色列表（多角色支持），后端 login 时填充 */
  roles?: RoleInfo[]
  permissions: string[]
  departmentId?: number
  departmentName?: string
}

// 用户信息
export interface UserInfo {
  id: number
  username: string
  realName: string
  email: string
  phone?: string
  department?: string
  role: string
  roleName: string
  permissions: string[]
  lastLoginTime?: string
}

// Token刷新响应
export interface TokenRefreshResponse {
  accessToken: string
  refreshToken: string
  expiresIn: string
  tokenType: string
}

// 登录
export function login(data: LoginRequest): Promise<LoginResponse> {
  return request.post<LoginResponse>('/auth/login', data) as unknown as Promise<LoginResponse>
}

// 登出
export function logout(userId: number, accessToken?: string, refreshToken?: string): Promise<void> {
  const params = new URLSearchParams()
  params.append('userId', userId.toString())
  if (accessToken) params.append('accessToken', accessToken)
  if (refreshToken) params.append('refreshToken', refreshToken)
  return request.post<void>(`/auth/logout?${params.toString()}`) as unknown as Promise<void>
}

// 获取用户信息
export function getUserInfo(userId: number): Promise<UserInfo> {
  return request.get<UserInfo>(`/auth/getUserInfo?userId=${userId}`) as unknown as Promise<UserInfo>
}

// 刷新Token - 同步版本，用于请求拦截器
export function refreshTokenApi(refreshToken: string): Promise<TokenRefreshResponse> {
  return request.post<TokenRefreshResponse>(
    `/auth/refreshToken?refreshToken=${encodeURIComponent(refreshToken)}`
  ) as unknown as Promise<TokenRefreshResponse>
}

// 检查用户名是否存在
export function checkUsername(username: string): Promise<{ exists: boolean }> {
  return request.get<{ exists: boolean }>(`/auth/checkUsername?username=${username}`) as unknown as Promise<{ exists: boolean }>
}

// 注册
export function register(data: {
  username: string
  password: string
  realName: string
  email?: string
  phone?: string
  department?: string
}): Promise<{ userId: number }> {
  return request.post<{ userId: number }>('/auth/register', data) as unknown as Promise<{ userId: number }>
}
